import { formatBpsValue } from "~/utils/formatBpsValue";
import { formatPercentValue } from "~/utils/functions/formatPercentValue";
import type { ScreenerAsset } from "../../types";

// // // //

export function formatAUM(aum: number | null): string {
    if (aum === null || aum <= 0) {
        return "—";
    }

    if (aum >= 1_000_000_000) {
        return `$${(aum / 1_000_000_000).toFixed(1)}B`;
    }

    if (aum >= 1_000_000) {
        return `$${(aum / 1_000_000).toFixed(1)}M`;
    }

    return `$${Math.round(aum).toLocaleString()}`;
}

export function formatHoldersCount(count: number | null): string {
    if (count === null || count <= 0) {
        return "—";
    }

    return Math.round(count).toLocaleString();
}

export function formatMinInvestment(
    minInvestment: ScreenerAsset["minInvestment"],
): string {
    if (minInvestment.amount === null || minInvestment.amount < 0) {
        return "None";
    }

    return `${Math.round(minInvestment.amount).toLocaleString()} ${minInvestment.currency}`;
}

export function formatFee(fee: number | null): string {
    if (fee === null) {
        return "—";
    }

    return `${formatPercentValue(formatBpsValue(fee) * 100)}%`;
}

export function formatList(values: string[]): string {
    if (values.length === 0) {
        return "—";
    }

    return values.join(", ");
}

export function formatNetworks(networks: ScreenerAsset["networks"]): string {
    if (networks.length === 0) {
        return "—";
    }

    return networks.map((network) => network.name).join(", ");
}

export function formatLiquidity(value: string | null): string {
    return value?.replace(/\s*\([^)]*\)/g, "").trim() || "—";
}
